<template>
  <div class="childbox relative">
    <div style="text-align: center">
      <h2>当{{ dateType1 }}用电量</h2>
    </div>
    <div class="chart_box3">
      <div class="box" :id="echartsId" ref="tapp" v-resize="resize"></div>
    </div>
  </div>
</template>

<script>
import uuidv1 from "uuid/v1";
export default {
  name: "",
  props: {
    pie: {
      type: [Object, Array],
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      bg_color1: "#4da6ff",
      btnNum: "one",
      myChart: null,
      dateType1: "",
      echartsId: uuidv1(),
    };
  },
  watch: {
    pie: {
      handler(newval, oldval) {
        this.fillPie(this.pie);
      },
      deep: true,
    },
  },
  mounted() {
    this.fillPie(this.pie);
  },
  methods: {
    resize() {
      this.myChart && this.myChart.resize();
    },
    fillPie(data) {
      let date;
      if (data.dateType == "day") {
        date = "日";
      } else if (data.dateType == "month") {
        date = "月";
      } else if (data.dateType == "year") {
        date = "年";
      }
      if (
        this.myChart != null &&
        this.myChart != "" &&
        this.myChart != undefined
      ) {
        this.myChart.resize();
      }
      this.dateType1 = date;
      this.myChart = this.$echarts.init(
        document.getElementById(this.echartsId)
      );
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}<br/> {c} ({d}%)",
        },
        // color: ["#d4953e", "#78b1e9", "#6ea562", "#e8855b", "#DC143C"],
        color: ["#00AAFF", "#52CCA3", "#CCCC00", "#e8855b"],
        legend: {
          orient: "horizontal",
          y: "bottom",
          bottom: "20",
          icon: "circle",
          formatter: function(val) {
            return val.split("/").join("\n");
          },
        },
        grid: {
          bottom: "50%",
          left: "5%",
          right: "5%",
          containLabel: true,
        },
        toolbox: {
          show: true,
          right: 20,
          feature: {
            saveAsImage: {},
          },
        },
        series: [
          {
            name: "当" + date + "用电",
            type: "pie",
            radius: "46%",
            data: data.yester,
            avoidLabelOverlap: true,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              // formatter: "{b}\n{c}kWh\n({d}%)",
              formatter: function(params) {
                let pieName = params.name.split("/").join(" ");
                let num = params.value;
                let percent = params.percent;
                return pieName + "\n" + num + "kWh" + "\n" + percent + "%";
              },
              color: "#000",
              fontWeight: "bolder",
            },
          },
        ],
      };
      this.myChart.setOption(option, true);
      let this_ = this;
      window.addEventListener("resize", function() {
        this_.myChart.resize();
      });
    },
    resizeEcharts() {
      if (
        this.myChart != null &&
        this.myChart != "" &&
        this.myChart != undefined
      ) {
        this.myChart.resize();
      }
    },
    // changeBtn(btnNum){
    //     this.btnNum = btnNum;
    //     if(this.btnNum == "one"){
    //         this.fillPie(this.pie.yester);
    //     }else if(this.btnNum == "two"){
    //         this.fillPie(this.pie.month);
    //     }else{
    //         this.fillPie(this.pie.year);
    //     }
    // }
  },
};
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #fff;
}
.flex {
  flex: 1;
  padding: 5px;
}
.childbox {
  width: 100%;
  height: 100%;
  background: #fff;
  flex: 1;
  border-radius: 6px;
  box-sizing: border-box;
  padding: 0px;
  margin-bottom: 10px;
  border: 1px solid #dedcdc;
  box-sizing: border-box;
}
.relative {
  position: relative;
}
.title_btn {
  height: 58px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  background: #dbdbdb;
}
.title_btn {
  .titdiv {
    flex: 1;
    font-size: 18px;
    font-weight: bold;
    color: #333;
    border-bottom: 1px solid #dedcdc;
    padding-left: 10px;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
}
.engTitle {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}
.title_btn button {
  height: 100%;
  text-align: center;
  float: left;
  line-height: 58px;
  padding: 0 10px;
  font-size: 14px;
  background: #dbdbdb;
  color: #000;
  font-weight: bold;
  border: 1px solid #dedcdc;
  box-sizing: border-box;
  cursor: pointer;
  border-radius: 0 !important;
  margin: 0 !important;
  border: none;
  border-bottom: 1px solid #dedcdc;
}
.title_btn .active {
  color: #1d6ce9;
  border-color: #dddddd;
  border-bottom: 6px solid #1d6ce9;
  font-weight: bold;
}
.btn_box {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
}
.chart_box3 {
  position: absolute;
  top: 58px;
  bottom: 0;
  width: 98%;
  padding: 5px;
  box-sizing: border-box;
}
.btn_box >>> .el-button {
  margin: 0 !important;
  border-radius: 0 !important;
}
</style>
